
export const ColorNumber = ({ children }: { children: React.ReactNode }) => {
    const value = Number(children);
    
    return (
        <span style={{ color: value > 0 ? "#EC722E" : "#a3b8e0" }}>
            {children}
        </span>
    );
};